import React from "react";
import "./style.scss";
import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface SpinnerProps {
    prefix: IconPrefix;
    icon: IconName;
    message?: string | React.ReactNode;
}

const Spinner = (props: SpinnerProps) => {
    return (
        <div className="vapor-spinner">
            <FontAwesomeIcon icon={[props.prefix, props.icon]} spin />
            {props.message && (
                <div className="vapor-spinner-message">{props.message}</div>
            )}
        </div>
    );
};

Spinner.defaultProps = {
    prefix: "far",
    icon: "circle-notch",
};

export default Spinner;
